import { Navigate, useLocation } from "react-router-dom";
import Helpers from "./helpers";
import { useSessionShellQuery } from "../../query/useSessionShell";

/**
 * Hard login gate: when logged in and pending RequiredForLogin agreements exist,
 * force signing before other authenticated routes. Mirrors MustChangePasswordGate
 * placement in App (runs after password gate clears).
 */
export default function RequiredAgreementsGate({ children }) {
  const location = useLocation();
  const path = (location.pathname || "/").toLowerCase();
  const { data, isLoading, isError } = useSessionShellQuery();

  if (Helpers.isLoginAgreementEscapePath(path)) {
    return children;
  }

  if (isLoading) {
    return <p className="fieldHint">Checking agreements…</p>;
  }

  // On error, do not hard-block the app; fail open to avoid lockout.
  if (isError || !data) {
    return children;
  }

  const pending = Helpers.pendingLoginAgreements(data);
  if (pending.length === 0) {
    return children;
  }

  const id = pending[0].AgreementID || pending[0].agreementID;
  if (!id) {
    return children;
  }

  const target = `/agreementSignature/${id}`;
  if (path === target.toLowerCase() || path.startsWith(`${target.toLowerCase()}/`)) {
    return children;
  }

  return (
    <Navigate
      to={target}
      replace
      state={{ returnTo: location.pathname, loginGate: true }}
    />
  );
}
